//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function data() {
    return {
      activeName: 'info'
    };
  },
  methods: {
    handleClick: function handleClick() {}
  }
};